<template>
<div class="" style="height: 100vh; width:100vw;">
   
  </div>
</template>

<script>
import { getAuth, signInWithEmailAndPassword} from 'firebase/auth';
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      email: "",
      password: "",
      Logo: require('@/assets/for doctors.png')

    };
  },
  methods: {

    ...mapActions(['updateEmail']),

    async signIn() {
      try {
        const userCredential = await signInWithEmailAndPassword(getAuth(), this.email, this.password);
        const user = userCredential.user;
        // Obtén el token de ID
        const idToken = await user.getIdToken();

        localStorage.setItem('Token', idToken);
        localStorage.setItem('Email', this.email);
        this.updateEmail(this.email);

        this.$router.push('/dermatologist-dashboard-new');
      } catch (error) {
        console.error('Error signing in: '+ error);
      }
    },
  },
};
</script>

<style>
body {
  background-image: url("../assets/nos_vemos_pronto.svg");
  background-repeat: no-repeat;
  background-size: cover; 
  background-position: center;
  overflow: hidden;
}
</style>